customElements.get("review-product") || customElements.define("review-product", class extends HTMLElement {
  constructor() {
    super(), this.sku = this.getAttribute("data-sku") || "", this.ratingNumberEl = this.querySelector("[data-rating-number]"), 
    this.ratingStarsEl = this.querySelector("[data-rating-stars]"), this.ratingCountEl = this.querySelector("[data-rating-count]"), 
    this.ratingTextEl = this.querySelector("[data-rating-text]");
  }
  async connectedCallback() {
    const t = this.dataset.manualRatingNumber, i = this.dataset.manualRatingTotal;
    if (t && i) this.displayManualRating(parseFloat(t), parseInt(i)); else if (window.Shopify?.app_config?.reviews_io?.store && this.sku.trim()) try {
      const t = await fetch(`https://api.reviews.io/product/rating-batch?store=${window.Shopify.app_config.reviews_io.store}&sku=${this.sku}`, {
        headers: {
          accept: "application/json"
        }
      });
      if (!t.ok) throw new Error(`HTTP error! status: ${t.status}`);
      const i = await t.json(), {totalRatings: e, ratingCount: n} = i.reduce((t, i) => ({
        totalRatings: t.totalRatings + parseFloat(i.average_rating * i.num_ratings || 0),
        ratingCount: t.ratingCount + parseInt(i.num_ratings || 0)
      }), {
        totalRatings: 0,
        ratingCount: 0
      }), a = t => {
        const i = String(t);
        if (i.includes(".")) {
          const [t, e] = i.split(".");
          return e.length > 1 ? `${t}.${e.slice(0, 1)}` : i;
        }
        return i;
      }, r = t => {
        const i = Math.max(0, Math.min(5, parseFloat(t))), e = Math.floor(i), n = 2.73 + 18 * e + 9.51 * (i - e);
        return Math.min(n / 86 * 100, 100);
      }, s = parseFloat((e / n).toFixed(2)) || 0;
      if (0 === s) return void (this.style.display = "none");
      [ s && this.ratingNumberEl && (this.ratingNumberEl.textContent = a(s)), s && this.ratingStarsEl && (this.ratingStarsEl.style.width = `${r(s)}%`), n && this.ratingCountEl && (this.ratingCountEl.textContent = n.toLocaleString()) ].some(Boolean) && (this.ratingTextEl && (this.ratingTextEl.textContent = n > 1 ? window.strings?.review?.other : window.strings?.review?.one), 
      setTimeout(() => this.classList.remove("opacity-0", "pointer-events-none"), 100));
    } catch (t) {
      console.error("Error fetching company review stats:", t);
    }
  }
  displayManualRating(t, i) {
    this.ratingNumberEl && (this.ratingNumberEl.textContent = (t => {
      const i = String(t);
      if (i.includes(".")) {
        const [t, e] = i.split(".");
        return e.length > 1 ? `${t}.${e.slice(0, 1)}` : i;
      }
      return i;
    })(t)), this.ratingStarsEl && (this.ratingStarsEl.style.width = `${(t => {
      const i = Math.max(0, Math.min(5, parseFloat(t))), e = Math.floor(i), n = 2.73 + 18 * e + 9.51 * (i - e);
      return Math.min(n / 86 * 100, 100);
    })(t)}%`), this.ratingCountEl && (this.ratingCountEl.textContent = i.toLocaleString()), 
    this.ratingTextEl && (this.ratingTextEl.textContent = `${i > 1 ? window.strings?.review?.other : window.strings?.review?.one}`), 
    this.classList.remove("opacity-0", "pointer-events-none");
  }
});